import { render } from "./TheTitle.vue?vue&type=template&id=65e53dc2&scoped=true"
const script = {}

import "./TheTitle.vue?vue&type=style&index=0&id=65e53dc2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e53dc2"]])

export default __exports__